import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { SubmitButton } from "../../components/Input";
import StateManagedSelect from "react-select";
import { API_URL } from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { showToast } from "../../components/toast";

const AddTradeproSubscriptionForm = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const [tableMapping, setTableMapping] = useState([]);
  const [dropdowns, setDropdowns] = useState({
    smsTemplates: [{ value: 0, label: "Select" }],
    pushTemplates: [{ value: 0, label: "Select" }],
    leadSources: [{ value: 0, label: "Select" }],
    userSources: [{ value: 0, label: "Select" }],
    whatsappTemplates: [{ value: 0, label: "Select" }],
    emailTemplates: [{ value: 0, label: "Select" }],
    eventList: [],
    scheduleList: [],
    fieldList: [],
    dateList: [],
    userList: [],
    serviceList: [],
    timeList: [],
  });

  const [workflowName, setWorkflowName] = useState("");
  const [selectedEventTypeOption, setSelectedEventTypeOption] = useState(null);
  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null);
  const [pickTime, setPickTime] = useState("");
  const [selectedCheckFieldList, setSelectedCheckFieldList] = useState(null);
  const [selectedUpdateFieldList, setSelectedUpdateFieldList] = useState(null);

  const [
    selectedAlertLeadSmsSourceSubscriberOption,
    setSelectedAlertLeadSmsSourceSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsSubscriberOption,
    setSelectedAlertLeadSmsSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadPushNotificationSubscriberOption,
    setSelectedAlertLeadPushNotificationSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsSourceExecutiveOption,
    setSelectedAlertLeadSmsSourceExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsExecutiveOption,
    setSelectedAlertLeadSmsExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadPushNotificationExecutiveOption,
    setSelectedAlertLeadPushNotificationExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadWhatsappSubscriberOption,
    setSelectedAlertLeadWhatsappSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertUserWhatsappExecutiveOption,
    setSelectedAlertUserWhatsappExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadEmailSubscriberOption,
    setSelectedAlertLeadEmailSubscriberOption,
  ] = useState(0);

  const [formData, setFormData] = useState({
    checkConditions: [],
    updateConditions: [],
  });

  const convertTimeStringToDate = (timeString) => {
    const [time, modifier] = timeString.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };

  const fetchDropdowns = async () => {
    try {
      const response = await axios.get(
        `${API_URL}workflowSubscription/dropdowns`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data.params;
      const formatted = {
        smsTemplates: [
          { value: 0, label: "Select" },
          ...(data.smslist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        pushTemplates: [
          { value: 0, label: "Select" },
          ...(data.pushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        leadSources: [
          { value: 0, label: "Select" },
          ...(data.leadsourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        userSources: [
          { value: 0, label: "Select" },
          ...(data.usersourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        whatsappTemplates: [
          { value: 0, label: "Select" },
          ...(data.whatsapppushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        emailTemplates: [
          { value: 0, label: "Select" },
          ...(data.emailtemplatelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        eventList: (data.eventlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        scheduleList: (data.schedulelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        fieldList: (data.fieldlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        dateList: (data.datelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        userList: (data.userlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        serviceList: (data.servicelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        timeList: (data.timelist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
      };
      setDropdowns(formatted);
      return formatted;
    } catch (error) {
      setError(error.message);
      return null;
    }
  };

  const fetchTableMapping = async () => {
    try {
      const response = await axios.get(
        `${API_URL}workflowSubscriber/tableMapping`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data.data || response.data;
      const formatted = Array.isArray(data) ? data : [];
      setTableMapping(formatted);
      return formatted;
    } catch (error) {
      setError(error.message);
      return [];
    }
  };

  const fetchWorkflow = async (
    currentMapping = tableMapping,
    currentDropdowns = dropdowns
  ) => {
    if (!id) return;
    try {
      const response = await axios.get(`${API_URL}workflowSubscription`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const workflowList =
        response.data.data?.data || response.data.data || response.data || [];
      const data = Array.isArray(workflowList)
        ? workflowList.find((dt) => dt.id == id) || {}
        : {};

      setWorkflowName(data.workflow_name || "");
      setSelectedEventTypeOption(data.event_type || null);
      setSelectedScheduleOption(data.scheduletype || null);
      setPickTime(
        data.scheduletime ? convertTimeStringToDate(data.scheduletime) : ""
      );

      // Process check conditions safely
      const checkConditions = Array.isArray(data.check_json)
        ? data.check_json
        : typeof data.check_json === "string"
        ? JSON.parse(data.check_json)
        : [];

      const populatedCheckConditions = await Promise.all(
        checkConditions.map(async (cond) => {
          const meta = await getFieldMeta(
            parseInt(cond.mapid),
            currentMapping,
            currentDropdowns
          );
          return {
            ...meta,
            mapId: cond.mapid,
            mapid: cond.mapid,
            conditionType: cond.conditiontype,
            fieldValue: cond.fieldvalue,
          };
        })
      );

      // Process update conditions safely
      const updateConditions = Array.isArray(data.update_json)
        ? data.update_json
        : typeof data.update_json === "string"
        ? JSON.parse(data.update_json)
        : [];

      const populatedUpdateConditions = await Promise.all(
        updateConditions.map(async (cond) => {
          const meta = await getFieldMeta(
            parseInt(cond.mapid),
            currentMapping,
            currentDropdowns
          );
          return {
            ...meta,
            mapId: cond.mapid,
            mapid: cond.mapid,
            fieldValue: cond.fieldvalue,
          };
        })
      );

      setFormData({
        ...data,
        checkConditions: populatedCheckConditions,
        updateConditions: populatedUpdateConditions,
      });

      setSelectedAlertLeadSmsSourceSubscriberOption(
        data.alert_lead_sms_source !== undefined && data.alert_lead_sms_source !== null
          ? data.alert_lead_sms_source
          : 0
      );
      setSelectedAlertLeadSmsSubscriberOption(
        data.alert_lead_sms !== undefined && data.alert_lead_sms !== null
          ? data.alert_lead_sms
          : 0
      );
      setSelectedAlertLeadPushNotificationSubscriberOption(
        data.alert_lead_push !== undefined && data.alert_lead_push !== null
          ? data.alert_lead_push
          : 0
      );
      setSelectedAlertLeadSmsSourceExecutiveOption(
        data.alert_user_sms_source !== undefined && data.alert_user_sms_source !== null
          ? data.alert_user_sms_source
          : 0
      );
      setSelectedAlertLeadSmsExecutiveOption(
        data.alert_user_sms !== undefined && data.alert_user_sms !== null
          ? data.alert_user_sms
          : 0
      );
      setSelectedAlertLeadPushNotificationExecutiveOption(
        data.alert_user_push !== undefined && data.alert_user_push !== null
          ? data.alert_user_push
          : 0
      );
      setSelectedAlertLeadWhatsappSubscriberOption(
        data.alert_lead_whatsapp_push !== undefined && data.alert_lead_whatsapp_push !== null
          ? data.alert_lead_whatsapp_push
          : 0
      );
      setSelectedAlertUserWhatsappExecutiveOption(
        data.alert_user_whatsapp_push !== undefined && data.alert_user_whatsapp_push !== null
          ? data.alert_user_whatsapp_push
          : 0
      );
      setSelectedAlertLeadEmailSubscriberOption(
        data.alert_lead_email !== undefined && data.alert_lead_email !== null
          ? data.alert_lead_email
          : 0
      );
    } catch (error) {
      console.error("Error fetching workflow data:", error);
      setError("Failed to load workflow data.");
      showToast.error("Failed to load workflow data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        const [dropdownsData, mappingData] = await Promise.all([
          fetchDropdowns(),
          fetchTableMapping(),
        ]);
        if (id && mappingData && dropdownsData) {
          await fetchWorkflow(mappingData, dropdownsData);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, [id]);

  const getFieldMeta = async (
    mapId,
    currentMapping = tableMapping,
    currentDropdowns = dropdowns
  ) => {
    const map = (currentMapping || []).find(
      (m) =>
        m.id == mapId ||
        Number(m.id) === Number(mapId) ||
        String(m.id) === String(mapId)
    );

    if (!map) {
      console.error(`Field mapping not found for ID: ${mapId}`);
      return null;
    }

    let droplist = [];
    let conditionOptions = {
      "=": "Is Equal To",
      "!=": "Not Equal To",
    };

    const mapid = map.dropid;

    if (map.field_type === "dropdown" && map.field_name == "serviceid") {
      droplist = currentDropdowns?.serviceList || [];
    } else if (
      map.field_type === "dropdown" &&
      map.field_name === "assigned_user"
    ) {
      droplist = currentDropdowns?.userList || [];
    } else if (map.field_type === "dropdown") {
      try {
        const response = await axios.get(
          `${API_URL}workflowSubscriber/pickuplist_sub?pid=${mapid}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const listData = response.data.data || response.data || [];
        droplist = Array.isArray(listData)
          ? listData.map((item) => ({
              label: item.pick_name,
              value: item.pick_name,
            }))
          : [];
      } catch (error) {
        console.error("Error fetching picklist:", error);
        droplist = [];
      }
    } else if (map.field_type === "date") {
      droplist = currentDropdowns?.dateList || [];
    } else if (map.field_type === "time") {
      droplist = currentDropdowns?.timeList || [];
    } else {
      conditionOptions = {
        ...conditionOptions,
        "<": "Less Than",
        "<=": "Less Than Equal To",
        ">": "Greater Than",
        ">=": "Greater Than Equal To",
      };
    }

    return {
      mapId: map.id,
      mapid: map.id,
      fieldType: map.field_type,
      fieldName: map.field_name,
      fieldLabel: map.field_description,
      fieldOptions: droplist,
      conditionOptions,
    };
  };

  const handleAddCondition = async () => {
    if (!selectedCheckFieldList) {
      showToast.error("Please select a field first");
      return;
    }
    const meta = await getFieldMeta(selectedCheckFieldList);

    if (!meta) {
      showToast.error("Failed to get field metadata");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      checkConditions: [
        ...(prev?.checkConditions || []),
        {
          mapId: meta.mapId,
          mapid: meta.mapId,
          fieldType: meta.fieldType,
          fieldName: meta.fieldName,
          fieldLabel: meta.fieldLabel,
          conditionType: "",
          fieldValue: "",
          fieldOptions: meta.fieldOptions,
          conditionOptions: meta.conditionOptions,
        },
      ],
    }));
    setSelectedCheckFieldList(null);
  };

  const handleAddUpdateValue = async () => {
    if (!selectedUpdateFieldList) {
      showToast.error("Please select a field first");
      return;
    }

    const meta = await getFieldMeta(selectedUpdateFieldList);

    if (!meta) {
      showToast.error("Failed to get field metadata");
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      updateConditions: [
        ...(prevData?.updateConditions || []),
        {
          mapId: meta.mapId,
          mapid: meta.mapId,
          fieldType: meta.fieldType,
          fieldName: meta.fieldName,
          fieldLabel: meta.fieldLabel,
          conditionType: "",
          fieldValue: "",
          fieldOptions: meta.fieldOptions,
          conditionOptions: meta.conditionOptions,
        },
      ],
    }));
    setSelectedUpdateFieldList(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formatTo12Hour = (date) => {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      const hr = hours % 12 || 12;
      const min = minutes.toString().padStart(2, "0");
      return `${hr}:${min} ${ampm}`;
    };

    const formattedCheckCondition = (formData.checkConditions || []).map((item) => ({
      mapid: item.mapId || item.mapid,
      fieldname: item.fieldName,
      fieldvalue: item.fieldValue,
      conditiontype: item.conditionType,
    }));

    const formattedUpdateCondition = (formData.updateConditions || []).map((item) => ({
      mapid: item.mapId || item.mapid,
      fieldname: item.fieldName,
      fieldvalue: item.fieldValue,
    }));

    const payload = {
      workflow_name: workflowName,
      event_type: selectedEventTypeOption,
      scheduletype: selectedScheduleOption ? selectedScheduleOption : "",
      scheduletime: pickTime ? formatTo12Hour(pickTime) : "",
      conditions: formattedCheckCondition,
      updates: formattedUpdateCondition,
      alert_user_sms_source: selectedAlertLeadSmsSourceExecutiveOption || 0,
      alert_lead_sms: selectedAlertLeadSmsSubscriberOption || 0,
      alert_lead_push: selectedAlertLeadPushNotificationSubscriberOption || 0,
      alert_user_push: selectedAlertLeadPushNotificationExecutiveOption || 0,
      alert_lead_sms_source: selectedAlertLeadSmsSourceSubscriberOption || 0,
      alert_lead_email: selectedAlertLeadEmailSubscriberOption || 0,
      alert_user_sms: selectedAlertLeadSmsExecutiveOption || 0,
      alert_lead_whatsapp_push: selectedAlertLeadWhatsappSubscriberOption || 0,
      alert_user_whatsapp_push: selectedAlertUserWhatsappExecutiveOption || 0,
    };

    console.log(payload);

    try {
      const url = id
        ? `${API_URL}workflowSubscription?id=${id}`
        : `${API_URL}workflowSubscription`;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201 || response.status === 200) {
        showToast.success(response.data.message);
        navigate("/Workflow/Subscription");
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    }
  };

  const handleRemoveCondition = (index) => {
    const newConditions = (formData.checkConditions || []).filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, checkConditions: newConditions });
  };

  const handleRemoveUpdateValue = (index) => {
    const newupdateConditions = (formData.updateConditions || []).filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, updateConditions: newupdateConditions });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <form onSubmit={handleSubmit}>
          <div className="panel panel-default with-rounded-corner with-shadow">
            <div className="panel-heading border-0">
              <span className="panel-title">
                {id ? "Edit " : "Add "}  Workflow Subscription - Tradepro
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Workflow Name</label>
                  <input
                    type="text"
                    name="workflow_name"
                    value={workflowName}
                    onChange={(e) => setWorkflowName(e.target.value)}
                    className="form-control"
                    placeholder="Enter Workflow Name"
                  />
                </div>
                <div className="col-md-3">
                  <label>Event Type</label>
                  <StateManagedSelect
                    options={dropdowns.eventList}
                    value={
                      selectedEventTypeOption
                        ? dropdowns.eventList.find(
                          (option) => option.value == selectedEventTypeOption
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedEventTypeOption(selected?.value)
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-3">
                  <label>Schedule Type</label>
                  <StateManagedSelect
                    options={dropdowns.scheduleList}
                    value={
                      selectedScheduleOption
                        ? dropdowns.scheduleList.find(
                          (option) => option.value == selectedScheduleOption
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedScheduleOption(selected?.value)
                    }
                    placeholder="--select--"
                    isDisabled={selectedEventTypeOption !== "schedule"}
                  />
                </div>
                <div className="col-md-2">
                  <label>Pick Time</label>
                  <DatePicker
                    selected={pickTime}
                    onChange={(date) => setPickTime(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    disabled={selectedScheduleOption !== "daily"}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <span className="panel-title">
                    <i className="fa fa-arrow-right"></i> Check Conditions
                  </span>
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Conditions</th>
                        <th>Field Value</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(formData.checkConditions || []).map((condition, index) => {
                        console.log(condition);

                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={condition.fieldLabel}
                                disabled
                              />
                            </td>
                            <td>
                              <select
                                className="form-control"
                                value={condition.conditionType}
                                onChange={(e) => {
                                  const updated = [...formData.checkConditions];
                                  updated[index].conditionType = e.target.value;
                                  setFormData({
                                    ...formData,
                                    checkConditions: updated,
                                  });
                                }}
                              >
                                {Object.entries(
                                  condition.conditionOptions || {}
                                ).map(([val, label]) => (
                                  <option key={val} value={val}>
                                    {label}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {condition.fieldType === "dropdown" ||
                                condition.fieldType === "date" ||
                                condition.fieldType === "time" ? (
                                <select
                                  className="form-control"
                                  value={condition.fieldValue || ""}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.checkConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      checkConditions: updated,
                                    });
                                  }}
                                >
                                  <option value="" disabled>
                                    --select--
                                  </option>
                                  {(condition.fieldOptions?.length > 0
                                    ? condition.fieldOptions
                                    : condition.fieldType === "date"
                                    ? dropdowns.dateList
                                    : condition.fieldType === "time"
                                    ? dropdowns.timeList
                                    : []
                                  )?.map((opt, idx) => {
                                    const value =
                                      typeof opt === "object" ? opt.value : opt;
                                    const label =
                                      typeof opt === "object" ? opt.label : opt;

                                    return (
                                      <option key={idx} value={value}>
                                        {label}
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.checkConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      checkConditions: updated,
                                    });
                                  }}
                                  placeholder="Enter Value"
                                />
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveCondition(index)}
                              >
                                X
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <StateManagedSelect
                            options={dropdowns.fieldList}
                            value={
                              selectedCheckFieldList
                                ? dropdowns.fieldList.find(
                                  (option) =>
                                    option.value == selectedCheckFieldList
                                )
                                : null
                            }
                            onChange={(selected) =>
                              setSelectedCheckFieldList(selected?.value)
                            }
                            placeholder="--select--"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddCondition}
                          >
                            Add Condition
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <span className="panel-title">
                    <i className="fa fa-arrow-right"></i> Update Values
                  </span>
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Field Value</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(formData.updateConditions || []).map((condition, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={condition.fieldLabel}
                                disabled
                              />
                            </td>
                            <td>
                              {condition.fieldType === "dropdown" ||
                                condition.fieldType === "date" ||
                                condition.fieldType === "time" ? (
                                <select
                                  className="form-control"
                                  value={condition.fieldValue || ""}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.updateConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      updateConditions: updated,
                                    });
                                  }}
                                >
                                  <option value="" disabled>
                                    --select--
                                  </option>
                                  {(condition.fieldOptions?.length > 0
                                    ? condition.fieldOptions
                                    : condition.fieldType === "date"
                                    ? dropdowns.dateList
                                    : condition.fieldType === "time"
                                    ? dropdowns.timeList
                                    : []
                                  )?.map((opt, idx) => {
                                    const value =
                                      typeof opt === "object" ? opt.value : opt;
                                    const label =
                                      typeof opt === "object" ? opt.label : opt;

                                    return (
                                      <option key={idx} value={value}>
                                        {label}
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <input
                                  type="text"
                                  className="form-control"
                                  value={condition.fieldValue}
                                  onChange={(e) => {
                                    const updated = [
                                      ...formData.updateConditions,
                                    ];
                                    updated[index].fieldValue = e.target.value;
                                    setFormData({
                                      ...formData,
                                      updateConditions: updated,
                                    });
                                  }}
                                  placeholder="Enter Value"
                                />
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveUpdateValue(index)}
                              >
                                X
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <StateManagedSelect
                            options={dropdowns.fieldList}
                            value={
                              selectedUpdateFieldList
                                ? dropdowns.fieldList.find(
                                  (option) =>
                                    option.value == selectedUpdateFieldList
                                )
                                : null
                            }
                            onChange={(selected) =>
                              setSelectedUpdateFieldList(selected?.value)
                            }
                            placeholder="--select--"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddUpdateValue}
                          >
                            Add Update Value
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12 my-2">
                  <span className="panel-title">Alerts:</span>
                </div>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label>Alert Lead SMS Source Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.leadSources}
                      value={
                        selectedAlertLeadSmsSourceSubscriberOption !== null &&
                        selectedAlertLeadSmsSourceSubscriberOption !== undefined
                          ? dropdowns.leadSources.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSourceSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSourceSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead SMS Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.smsTemplates}
                      value={
                        selectedAlertLeadSmsSubscriberOption !== null &&
                        selectedAlertLeadSmsSubscriberOption !== undefined
                          ? dropdowns.smsTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Push Notification Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.pushTemplates}
                      value={
                        selectedAlertLeadPushNotificationSubscriberOption !== null &&
                        selectedAlertLeadPushNotificationSubscriberOption !== undefined
                          ? dropdowns.pushTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadPushNotificationSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadPushNotificationSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead SMS Source Executive</label>
                    <StateManagedSelect
                      options={dropdowns.userSources}
                      value={
                        selectedAlertLeadSmsSourceExecutiveOption !== null &&
                        selectedAlertLeadSmsSourceExecutiveOption !== undefined
                          ? dropdowns.userSources.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsSourceExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsSourceExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Sms Executive</label>
                    <StateManagedSelect
                      options={dropdowns.smsTemplates}
                      value={
                        selectedAlertLeadSmsExecutiveOption !== null &&
                        selectedAlertLeadSmsExecutiveOption !== undefined
                          ? dropdowns.smsTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadSmsExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadSmsExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Push Notification Executive</label>
                    <StateManagedSelect
                      options={dropdowns.pushTemplates}
                      value={
                        selectedAlertLeadPushNotificationExecutiveOption !== null &&
                        selectedAlertLeadPushNotificationExecutiveOption !== undefined
                          ? dropdowns.pushTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadPushNotificationExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadPushNotificationExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Whatsapp Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.whatsappTemplates}
                      value={
                        selectedAlertLeadWhatsappSubscriberOption !== null &&
                        selectedAlertLeadWhatsappSubscriberOption !== undefined
                          ? dropdowns.whatsappTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadWhatsappSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadWhatsappSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Whatsapp Executive</label>
                    <StateManagedSelect
                      options={dropdowns.whatsappTemplates}
                      value={
                        selectedAlertUserWhatsappExecutiveOption !== null &&
                        selectedAlertUserWhatsappExecutiveOption !== undefined
                          ? dropdowns.whatsappTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertUserWhatsappExecutiveOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertUserWhatsappExecutiveOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Alert Lead Email Subscriber</label>
                    <StateManagedSelect
                      options={dropdowns.emailTemplates}
                      value={
                        selectedAlertLeadEmailSubscriberOption !== null &&
                        selectedAlertLeadEmailSubscriberOption !== undefined
                          ? dropdowns.emailTemplates.find(
                              (option) =>
                                option.value ==
                                selectedAlertLeadEmailSubscriberOption
                            ) || null
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedAlertLeadEmailSubscriberOption(
                          selected ? selected.value : 0
                        )
                      }
                      placeholder="--select--"
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <SubmitButton
                  handleSubmit={handleSubmit}
                  pageBack={`/Workflow/Subscription`}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTradeproSubscriptionForm;
